export default {
  namespaced: true,
  state: {
    all: [],
    loading: false
  },
  getters: {
    all: (state) => state.all,
    find: (state) => (id) => state.all.find((discipline) => discipline.id == id),
    loading: (state) => state.loading
  },
  mutations: {
    startLoading(state) {
      state.loading = true
    },
    stopLoading(state) {
      state.loading = false
    },
    setAll(state, disciplines) {
      state.all = disciplines.sort((a, b) => {
        const first  = a['name'].toUpperCase()
        const second = b['name'].toUpperCase()

        if (first < second) return -1
        if (first > second) return 1
        return 0
      })

      state.loading = false
    }
  },
  actions: {
    fetchAll({ commit }) {
      commit('startLoading')
      return Vue.$http.get('disciplines').then(
        (response) => commit('setAll', response.data),
        (response) => commit('stopLoading')
      )
    }
  }
}
